// extracted by mini-css-extract-plugin
export default {"header":"wLvtebjEca6eToulzGAi","logo":"zhfAXOol2CmzPW4mPPX4"};